<template>
    <site-img
        v-if="partners && partners.length"
        class="md-partner broker"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="containerStyle"
    >
        <module-box
            class="full-space"
            :fullColumn="fullColumn"
            noPadding
            noMargin
            @mouseenter.native="playSlider(false)"
            @mouseleave.native="playSlider(true)"
        >
            <div class="mg-title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div
                class="partner-container"
                v-if="partners && partners.length > 0"
                ref="swiperContainer"
            >
                <ul ref="swiper" class="slider-container">
                    <li
                        v-for="(partner, index) in clonePartner"
                        :key="index"
                        class="partner-item"
                    >
                        <partner-logo
                            @load="calcMoveWidth"
                            :partner="partner"
                        ></partner-logo>
                    </li>
                </ul>
            </div>
        </module-box>
    </site-img>
</template>

<script>
import common, { swiperMixin } from '../index';
export default {
    mixins: [common, swiperMixin],
    data: function() {
        return {
            isMobilePlay: false,
            swiperMargin: {
                pc: 67,
                mobile: 20
            }
        };
    },
    mounted() {
        this.initSwiper();
        this.resizeListener();
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-partner.broker {
    .mg-title {
        width: 100%;
        padding-bottom: 40px;
        font: var(--mg-title-size) var(--mg-title-font);
        // overflow: hidden;
        @include media-600 {
            padding-bottom: 20px;
            p {
                font-size: var(--mg-title-size-mobile) !important;
            }
        }
        // p {
        //     white-space: nowrap;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        // }
    }
    .partner-container {
        display: flex;
        justify-content: space-between;
        .slider-container {
            display: flex;
            overflow: hidden;
            justify-content: center;
            width: 100%;
            .partner-item {
                margin-right: 67px;
                //  Avoid line height caused by anonymous spaces
                line-height: 0;
                @include media-600 {
                    margin-right: 20px;
                }
                .partner-img {
                    filter: grayscale(1);
                    cursor: pointer;
                    &:hover {
                        filter: none;
                    }
                }
            }
        }
        .iconfont {
            font-size: 40px;
            line-height: 48px;
            opacity: 0.6;
            color: #c6c8d1;
        }
        .md-partner.partner-logo {
            &.partner-img,
            .partner-img {
                height: 40px;
            }
        }
    }

    @include media-600 {
        .partner-container {
            .slider-container {
                overflow-x: hidden;
                margin-top: -25px;
                flex-wrap: wrap;
                &::-webkit-scrollbar {
                    display: none;
                }
                .partner-item {
                    margin: 25px 20px 0 0;
                }
            }

            .iconfont {
                display: none;
            }
        }
    }
}
</style>
